/**
 * Generates srcSet and sizes for Supabase Storage images
 * Uses the /render/image/ endpoint for on-the-fly resizing
 */

const SUPABASE_STORAGE_PATTERN = /\/storage\/v1\/object\/public\//;

function toRenderUrl(url: string, width: number): string {
  return url.replace(
    /\/storage\/v1\/object\/public\//,
    '/storage/v1/render/image/public/'
  ) + `?width=${width}&resize=contain`;
}

export function getResponsiveProps(
  url: string | undefined,
  sizes: string = '100vw'
): { src: string; srcSet?: string; sizes?: string } {
  if (!url) return { src: '' };

  // Only transform Supabase storage URLs
  if (!SUPABASE_STORAGE_PATTERN.test(url)) {
    return { src: url };
  }

  const widths = [640, 960, 1280, 1920];
  const srcSet = widths
    .map(w => `${toRenderUrl(url, w)} ${w}w`)
    .join(', ');

  return { src: url, srcSet, sizes };
}
